export default __webpack_public_path__ + "static/media/surveyMobileAd.98aeeb3d.png";